import Icon from '@components/officialWebStore/common/Icon.vue';
import Select from '@components/officialWebStore/common/Select.vue';
import Button from '@components/officialWebStore/common/Button.vue';
import SelectGroup from '@components/officialWebStore/common/SelectGroup.vue';
import Input from '@components/officialWebStore/common/Input.vue';
import PopupWindow from '@components/officialWebStore/common/PopupWindow.vue';
import DataList from '@components/officialWebStore/common/DataList.vue'

export default {
  install(Vue) {
    Vue.component('Icon', Icon);
    Vue.component('Select', Select);
    Vue.component('Button', Button);
    Vue.component('SelectGroup', SelectGroup);
    Vue.component('InputComp', Input);
    Vue.component('PopupWindow', PopupWindow);
    Vue.component('DataList', DataList);
  }
};
